import { render, staticRenderFns } from "./VPhoneInput.vue?vue&type=template&id=516fdaf0"
import script from "./VPhoneInput.vue?vue&type=script&lang=js"
export * from "./VPhoneInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports